import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextinputField from "../../CommonComponents/TextInputField/TextinputField";
import StyledCheckBoxLabel from "../../CommonComponents/StyledCheckbox/StyledCheckBoxLabel";
import StyledTextarea from "../../CommonComponents/StyledTextarea/StyledTextarea";
import {useTheme} from "../../../contexts/theme";
import {FormControl} from "@mui/material";
interface DailyMotionFormProps {
    onFieldChange: (field: string, value: string | boolean) => void;
    dailyMotionFormState: DailyMotionFormState
}

export interface DailyMotionFormState {
    title: string;
    description: string;
    is_created_for_kids: boolean;
    private: boolean;
    channel_id: string;
}

const DailyMotionForm: React.FC<DailyMotionFormProps> = ({onFieldChange, dailyMotionFormState}) => {
    const theme = useTheme()
    const inputTextStyle = {
        borderBottomColor:theme.palette.orange,
        marginBottom: theme.spacing.md,
        backgroundColor: 'none',
        color: theme.palette.white,
        borderColor: theme.palette.white,
        borderRadius: theme.border.width.hard
    }

    return (
        <Grid container marginTop={theme.spacing.md}>
            <Grid item lg={6} md={12} paddingRight={theme.spacing.md}>
                <Box display="flex" flexDirection={'column'}>
                    <TextinputField
                        value={dailyMotionFormState.title}
                        name={"dailyMotionTitle"}
                        placeholder={"Insert dailyMotion title"}
                        type={'text'}
                        variant={'outlined'}
                        onChange={(e) => onFieldChange('title', e.target.value)}
                        {...inputTextStyle}
                    />
                    <TextinputField
                        value={dailyMotionFormState.channel_id}
                        name={"dailyMotionTitle"}
                        placeholder={"Insert Channel ID"}
                        type={'text'}
                        variant={'outlined'}
                        onChange={(e) => onFieldChange('channel_id', e.target.value)}
                        {...inputTextStyle}
                    />
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <StyledCheckBoxLabel
                            label={"Private"}
                            checked={dailyMotionFormState.private}
                            onChange={(e) => onFieldChange('private', (e.target as any).checked)}
                        />
                        <StyledCheckBoxLabel
                            label={"Only Children"}
                            checked={dailyMotionFormState.is_created_for_kids}
                            onChange={(e) => onFieldChange('is_created_for_kids', (e.target as any).checked)}
                        />
                    </Box>
                </Box>
            </Grid>
            <Grid item lg={6} md={12}>
                <StyledTextarea
                    placeholder={'Type post description'}
                    label={'Description'}
                    value={dailyMotionFormState.description}
                    onChange={(e) => onFieldChange('description', e.target.value)}
                    width={'100%'}
                    height={'100%'}
                />
            </Grid>
        </Grid>
    )
}

export default DailyMotionForm